import { render, staticRenderFns } from "./BranchEdit.vue?vue&type=template&id=7e988b41&scoped=true"
import script from "./BranchEdit.vue?vue&type=script&lang=js"
export * from "./BranchEdit.vue?vue&type=script&lang=js"
import style0 from "./BranchEdit.vue?vue&type=style&index=0&id=7e988b41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e988b41",
  null
  
)

export default component.exports